import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

const ScrollReveal = ({ children, direction = 'up', delay = 0, duration = 0.6 }) => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsIntersecting(true);
                    // Once it animates, we can unobserve to save browser layout processing power
                    if (ref.current) observer.unobserve(ref.current);
                }
            },
            { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => observer.disconnect();
    }, []);

    const getDirectionStyles = () => {
        switch (direction) {
            case 'up': return { transform: isIntersecting ? 'translateY(0)' : 'translateY(40px)' };
            case 'down': return { transform: isIntersecting ? 'translateY(0)' : 'translateY(-40px)' };
            case 'left': return { transform: isIntersecting ? 'translateX(0)' : 'translateX(40px)' };
            case 'right': return { transform: isIntersecting ? 'translateX(0)' : 'translateX(-40px)' };
            case 'scale': return { transform: isIntersecting ? 'scale(1)' : 'scale(0.92)' };
            default: return {};
        }
    };

    return (
        <Box
            ref={ref}
            sx={{
                opacity: isIntersecting ? 1 : 0,
                ...getDirectionStyles(),
                transition: `opacity ${duration}s cubic-bezier(0.215, 0.610, 0.355, 1) ${delay}s, transform ${duration}s cubic-bezier(0.215, 0.610, 0.355, 1) ${delay}s`,
                willChange: 'transform, opacity'
            }}
        >
            {children}
        </Box>
    );
};

export default ScrollReveal;